/**
 * W1 — Action registry (타 스트림이 action 등록 — resolver 코어 미변경)
 */

import { assertRegisterableWorkbenchAction } from './domain-kernel-handler-coverage';
import type { WorkbenchAction } from './action-types';

const registeredActions: WorkbenchAction[] = [];

export function registerWorkbenchActions(actions: WorkbenchAction[]): void {
  for (const action of actions) {
    assertRegisterableWorkbenchAction(action);
    if (!registeredActions.some((existing) => existing.id === action.id)) {
      registeredActions.push(action);
    }
  }
}

export function clearWorkbenchActionRegistry(): void {
  registeredActions.length = 0;
}

export function getRegisteredWorkbenchActions(): readonly WorkbenchAction[] {
  return registeredActions;
}
